module.exports = __webpack_public_path__ + "static/media/spinachmushroomandcornlasagna.5279aeb1.jpg";